import React from "react";
import Batch from "../Batch";

const CompletedBatches = () => {
    return <Batch status="completed" title="Completed" />;
};

export default CompletedBatches;
